import type { TileCatalogAdminData } from "@/app/admin/adminTypes";

export function classNames(...values: Array<string | false | null | undefined>): string {
  return values.filter(Boolean).join(" ");
}

export function searchMatches(value: string, query: string): boolean {
  if (!query.trim()) {
    return true;
  }

  return value.toLowerCase().includes(query.trim().toLowerCase());
}

export function getSystemCatalogData(data: TileCatalogAdminData): TileCatalogAdminData {
  const systemTileSets = data.tileSets.filter((tileSet) => tileSet.namespace === "system");
  const systemTileSetIdSet = new Set(systemTileSets.map((tileSet) => tileSet.id));
  const systemTileIdSet = new Set(
    data.tileSetOrderEntries
      .filter((entry) => systemTileSetIdSet.has(entry.parent_tile_set_id) && entry.tile_id !== null)
      .flatMap((entry) => (entry.tile_id ? [entry.tile_id] : [])),
  );

  return {
    ...data,
    tileSets: systemTileSets,
    tileSetOrderEntries: data.tileSetOrderEntries.filter(
      (entry) =>
        systemTileSetIdSet.has(entry.parent_tile_set_id) &&
        (entry.child_tile_set_id === null || systemTileSetIdSet.has(entry.child_tile_set_id)),
    ),
    collectionTileSets: data.collectionTileSets.filter((entry) =>
      systemTileSetIdSet.has(entry.tile_set_id),
    ),
    tileSetTaxonomyNodes: data.tileSetTaxonomyNodes.filter((entry) =>
      systemTileSetIdSet.has(entry.tile_set_id),
    ),
    tiles: data.tiles.filter((tile) => systemTileIdSet.has(tile.id)),
  };
}

export function buildTileCountByTileSetId(
  data: Pick<TileCatalogAdminData, "tileSetOrderEntries">,
): Map<string, number> {
  const counts = new Map<string, number>();

  for (const entry of data.tileSetOrderEntries) {
    if (!entry.tile_id) {
      continue;
    }
    counts.set(entry.parent_tile_set_id, (counts.get(entry.parent_tile_set_id) ?? 0) + 1);
  }

  return counts;
}
